import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
// Angular Imports
import { NgModule } from '@angular/core';
import { ModalModule } from 'ngx-bootstrap/modal';
import { TabsModule } from 'ngx-bootstrap/tabs';
// This Module's Components
import { CheckinConfirmationNoComponent } from './checkin-confirmation-no.component';

@NgModule({
  imports: [
    CommonModule,
    HttpClientModule,
    ModalModule.forRoot(),
    TabsModule.forRoot()
  ],
  declarations: [CheckinConfirmationNoComponent],
  exports: [CheckinConfirmationNoComponent]
})
export class CheckinConfirmationNoModule {}
